import _ from 'lodash';
import { createSelector } from 'reselect';
import { getMetadataState } from 'reducers/responseMetadata';
import { getAssets } from 'reducers/responseAsset';
import { getUserType, getRegion } from 'reducers/selectors/user';
import { getSafeAppbehaviour } from 'reducers/nav/selectors';
import { GetRegion } from 'constants.js';
import { getAvailableChannels } from 'utils/getAvaibleChannel';
import Logger from 'services/logger';

export const nodeToCarousel = (node, assets) => {
  const region = GetRegion();

  const getAppBehaviour = child => {
    try {
      return child?.app_behaviour &&
        JSON.parse(child?.app_behaviour) &&
        JSON.parse(child?.app_behaviour)?.layout
        ? JSON.parse(child?.app_behaviour)?.layout?.indexOf('guidechannels') >
            -1
        : false;
    } catch (error) {
      Logger.warn('== > ', error);
      return false;
    }
  };

  const currentNodeToCarousel = {
    image_large:
      assets && assets[`nav_${region}_${node.code}_over`]
        ? `nav_${region}_${node.code}_over`
        : `nav_${node.code}_over`,
    image_medium:
      assets && assets[`nav_${region}_${node.code}_over`]
        ? `nav_${region}_${node.code}_over`
        : `nav_${node.code}_over`,
    image_small:
      assets && assets[`nav_${region}_${node.code}_over`]
        ? `nav_${region}_${node.code}_over`
        : `nav_${node.code}_over`,
    code: node.code,
    type: 'playAndGo',
    isFirst: true,
  };
  const CHILDS = node.childs || [];

  const childsToCarousel = CHILDS.map(child => ({
    image_large:
      assets && assets[`nav_${region}_${child.code}`]
        ? `nav_${region}_${child.code}`
        : `nav_${child.code}`,
    image_medium:
      assets && assets[`nav_${region}_${child.code}`]
        ? `nav_${region}_${child.code}`
        : `nav_${child.code}`,
    image_small:
      assets && assets[`nav_${region}_${child.code}`]
        ? `nav_${region}_${child.code}`
        : `nav_${child.code}`,
    code: child.code,
    type: 'playAndGo',
    isFirst: false,
    isGuideChannels: getAppBehaviour(child),
  }));

  return {
    type: 'playAndGo',
    carosuel: [currentNodeToCarousel, ...childsToCarousel],
  };
};

export const getNavigation = state => _.get(state, 'navigation');

const getDefaultsGroupId = state => {
  try {
    return JSON.parse(_.get(state, ['metadata', 'default_group_id_channel']));
  } catch (error) {
    Logger.warn(error);
    return {};
  }
};

export const getIsNewNavigation = createSelector(
  [getNavigation],
  state => _.get(state, ['isNewNavigationExperience']),
);

export const getDefaultChannel = createSelector(
  getDefaultsGroupId,
  getRegion,
  (defaultsChannel, region) =>
    defaultsChannel[region] || defaultsChannel.default,
);

export const getNavData = createSelector(
  [getNavigation],
  nav => _.get(nav, 'model'),
);

export const getNavVisibility = createSelector(
  [getMetadataState],
  metadata => JSON.parse(_.get(metadata, 'nav_visibility', '{}')),
);

export const getDefaultChannelFromEpg = state => {
  const resultChannelAvaible = getAvailableChannels();
  return resultChannelAvaible[0]
    ? resultChannelAvaible[0]?.group_id
    : getDefaultChannel(state);
};

export const getDefaultChannelDataFromEpg = state => {
  const resultChannelAvaible = getAvailableChannels();
  return resultChannelAvaible[0] ? resultChannelAvaible[0] : {};
};

export const filterNav = createSelector(
  [getNavData, getNavVisibility, getUserType, getAssets],
  (navData, navVisibility, userType, assets) => {
    const NAV_VISIBILITY_BY_CODE = _.keyBy(navVisibility, 'code');
    const USER_TYPE = userType?.toLowerCase();
    const filtered = _.reduce(
      navData,
      (filterNavData, node) => {
        const nodeVisibilitConfig = NAV_VISIBILITY_BY_CODE[node.code];
        const imageItem = assets[`ic_imgmenu_${node.code}`];
        const iconItem = assets[`ic_menu_${node.code}`];
        if (
          _.isNil(nodeVisibilitConfig) ||
          nodeVisibilitConfig[USER_TYPE] === 1
        ) {
          return [...filterNavData, { imageItem, iconItem, ...node }];
        }
        return [...filterNavData];
      },
      [],
    );
    return filtered;
  },
);

export const getHasNodeMusicEnabled = createSelector(
  [getNavData],
  navigationNodes =>
    _.some(
      navigationNodes,
      node => getSafeAppbehaviour(node.app_behaviour).layout === 'claromusica',
    ),
);
